import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useState } from 'react';
import { Button } from '../../../../../../../components/Button';
import { InlineValueEditor } from '../../../../../../../components/entities/InlineValueEditor';
import { styleSheet } from '../../styles';
import { WebsiteCard } from './WebsiteCard';

type Props = {
	contact: Api.IContact;
	onWebsiteChanged: (website: string) => void;
};

export const WebsiteList = ({ contact, onWebsiteChanged }: Props) => {
	const [isAdding, setIsAdding] = useState(false);
	const [websiteValue, setWebsiteValue] = useState('');

	const onSaveNewWebsite = () => {
		onWebsiteChanged(websiteValue);
		setIsAdding(false);
		setWebsiteValue('');
	};

	const onWebsiteUpdated = (newWebsite: string) => {
		onWebsiteChanged(newWebsite);
	};

	const onDeleteWebsite = () => {
		onWebsiteChanged('');
	};

	return (
		<div className={css(styleSheet.contactDetailSection)}>
			<div className={css(styleSheet.emailCardContainer)}>
				{contact.webSite && (
					<WebsiteCard website={contact.webSite} onWebsiteChanged={onWebsiteUpdated} onDelete={onDeleteWebsite} />
				)}

				{!contact.webSite && !isAdding && (
					<div className={css(styleSheet.emailCardAddButton)}>
						<Button
							kind='link'
							onClick={() => {
								setIsAdding(true);
								setWebsiteValue('');
							}}
						>
							+ Add Website
						</Button>
					</div>
				)}

				{isAdding && (
					<InlineValueEditor
						autoComplete='off'
						autoFocus={true}
						compactLayout={true}
						id='website-editor-input'
						onCancelButtonClicked={() => setIsAdding(false)}
						onChange={ev => setWebsiteValue(ev.target.value)}
						onKeyDown={ev => {
							if (ev.keyCode === 13) {
								onSaveNewWebsite();
							}
						}}
						onSaveButtonClicked={onSaveNewWebsite}
						value={websiteValue || ''}
						placeholder='Enter website URL'
					/>
				)}
			</div>
		</div>
	);
};
